import tw from 'twin.macro'

export const base = [tw`text-base font-brand text-primary`]
export const title = [tw`font-bold text-3xl mb-4`]
export const subtitle = [tw`font-medium text-2xl mb-4`]
export const headline = [tw`font-medium text-xl`]
export const caption = [tw`font-medium text-sm text-gray-500 leading-tight`]
export const hint = [tw`font-sans font-normal text-xs text-gray-400 leading-4`]
